<div class="videos-config-container">
  <h1>Configuración Videos</h1>

  <div class="alert alert-success" *ngIf="successMessage">
    <i class="fa fa-check-circle" aria-hidden="true"></i> {{ successMessage }}
  </div>

  <div class="alert alert-danger" *ngIf="errorMessage">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    {{ errorMessage }}
  </div>

  <div class="videos-grid">
    <!-- Video cards usando el componente reutilizable -->
    <app-video-card
      *ngFor="let config of videoConfigs"
      [config]="config"
      [videoUrl]="videoUrls[config.key]"
      [loading]="isVideoLoading(config.key)"
      (updateVideo)="actualizarVideoDirectamente($event)"
      (visualizeVideo)="visualizarVideo($event)"
      (videoUrlChange)="onVideoUrlChange(config.key, $event)"
    ></app-video-card>
  </div>

  <!-- Video Visualizer Modal -->
  <div
    *ngIf="mostrarVisualizadorVideo"
    class="video-visualizer"
    (click)="cerrarVisualizador()"
  >
    <div class="video-visualizer-content" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="cerrarVisualizador()">
        &times;
      </button>

      <!-- Usar nuestro componente reutilizable YouTube Player -->
      <app-youtube-player
        *ngIf="videoIdActual"
        [videoId]="videoIdActual"
      ></app-youtube-player>

      <!-- Mensaje de error si no hay video ID -->
      <div *ngIf="!videoIdActual" class="error-message">
        <p>No se pudo extraer el ID del video de YouTube</p>
      </div>
    </div>
  </div>
</div>
